<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useResume } from '@/composables/useResume'
import { vTilt } from '@/directives/tilt'

const { content } = useResume()
const { t } = useI18n()
</script>

<template>
  <section id="skills">
    <div class="wrap">
      <div class="sec-head reveal">
        <div class="eyebrow"><span class="eyebrow-idx">02 /</span> {{ content.sectionTitles.skills }}</div>
        <h2 class="sec-title">{{ t('sections.skillsTitle') }}</h2>
        <p class="sec-sub">{{ content.sectionTitles.skillsSub }}</p>
      </div>
      <div class="skills-grid">
        <div
          v-for="(group, i) in content.skills.groups"
          :key="i"
          v-tilt="6"
          class="skill-card glass reveal"
          :class="`d${i + 1}`"
        >
          <div class="skill-head">
            <span class="skill-label">{{ group.label }}</span>
            <span class="skill-dots">
              <span v-for="n in 4" :key="n" class="d" :class="{ on: n <= group.level }"></span>
            </span>
          </div>
          <div class="skill-items">
            <span v-for="(item, j) in group.items" :key="j" class="skill-pill">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
